/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-05 11:29:10
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import React, { Component } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withI18n } from '@shopify/react-i18n';
import { getFormValues } from 'redux-form';

import GeneralPreview from 'src/components/views/theme-settings/preview';
import { MENU_ID } from 'src/constants/theme-settings.jsx';
import * as ProductActions from 'src/stores/actions/product-actions';
import { DEVICE } from 'src/constants/theme-settings';

type PropsFromState = {
  themeId: string | number,
  themeName: string,
  activeMenuItem: string,
  isExpandFullscreen: boolean,
  tenantApp: any,
  formValues: any,
  selectedPage: string,
  previewSetting: any,
  labelTranslation: any,
  primaryLocale: string,
  currency: string,
  country: string,
  boostThemeLib: string,
  boostThemeLibVersion: string
};

type PropsFromDispatch = {};

type ComposedProps = PropsFromState & PropsFromDispatch & WithI18nProps;

class PreviewVisualEditor extends Component<ComposedProps, State> {
  state = {};

  componentDidMount() {
    const { getPreviewProducts } = this.props;

    getPreviewProducts({ size: 5 });
  }

  render() {
    const {
      isExpandFullscreen,
      tenantApp,
      formValues,
      activeMenuItem,
      themeId,
      themeInfo,
      themeName,
      selectedPage,
      previewSetting,
      previewProductData,
      device,
      labelTranslation,
      primaryLocale,
      currency,
      country,
      boostThemeLib,
      boostThemeLibVersion,
      themeSettingDefaultValue,
      themeSettingDefaultThemeValue,
    } = this.props;

    const previewClass = classnames('visual-editor-preview', {
      full: isExpandFullscreen,
      'overflow-hidden':
        activeMenuItem === MENU_ID.QUICK_VIEW || activeMenuItem === MENU_ID.AJAX_CART
    });

    // const btnExpandClass = classnames('btn-expand', {
    //   show: !isExpandFullscreen
    // });

    return (
      <div className={previewClass}>
        {/* <div className={btnExpandClass} onClick={this.handleToggleFullscreen}>
          <Icon source={ChevronLeftMinor} color="base" />
        </div> */}
        <GeneralPreview
          formValues={formValues}
          activeMenuItem={activeMenuItem}
          tenantApp={tenantApp}
          themeName={themeName}
          themeId={themeId}
          themeInfo={themeInfo}
          selectedPage={selectedPage}
          previewSetting={previewSetting}
          previewProductData={previewProductData}
          isExpandFullscreen={isExpandFullscreen}
          device={device}
          labelTranslation={labelTranslation}
          primaryLocale={primaryLocale}
          currency={currency}
          country={country}
          boostThemeLib={boostThemeLib}
          boostThemeLibVersion={boostThemeLibVersion}
          themeSettingDefaultValue={
            !_.isEmpty(themeSettingDefaultValue)
              ? themeSettingDefaultValue
              : themeSettingDefaultThemeValue
          }
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  getPreviewProducts: (value, i18n) => dispatch(ProductActions.getPreviewProducts(value, i18n))
});

const mapStateToProps = (state, props) => {
  const formValues = getFormValues('ThemeSettingVisualEditorForm')(state) || {};
  const tenantApp = _.get(state.oauth, 'tenantApp', {});
  const externalInfo = _.get(tenantApp, 'externalInfo', {});
  const themes: Array<any> = _.get(state.themeSetup, 'themes', []);
  const themeInfo = themes.find(theme => `${theme.id}` === props.themeId);

  const previewProductData = {
    shop: _.get(state, 'product.shop', []),
    products: _.get(state, 'product.products', [])
  };

  const isExpandFullscreen = _.get(state, 'themeSetting.device') === DEVICE.FULLSCREEN;

  return {
    formValues,
    tenantApp,
    themeInfo,
    previewProductData,
    activeMenuItem: _.get(state, 'themeSetting.activeMenuItem', ''),
    isExpandFullscreen,
    themeName: _.get(state, 'themeSetting.themeName', ''),
    selectedPage: _.get(state, 'themeSetting.selectedPage', ''),
    previewSetting: _.get(state, 'themeSetting.previewSetting', {}),
    device: _.get(state, 'themeSetting.device'),
    labelTranslation: _.get(state, 'themeSetting.labelTranslation', {}),
    primaryLocale: _.get(tenantApp, 'externalInfo.primary_locale', 'en'),
    country: _.get(externalInfo, 'country_code', ''),
    currency: _.get(externalInfo, 'currency', ''),
    boostThemeLib: _.get(state, 'themeSetting.boostThemeLib', ''),
    boostThemeLibVersion: _.get(state, 'themeSetting.boostThemeLibVersion', ''),
    themeSettingDefaultValue: _.get(state, 'themeSetting.themeSettingDefaultValue', {}),
    themeSettingDefaultThemeValue: _.get(state, 'themeSetting.themeSettingDefaultThemeValue', {}),
    filterLayout: _.get(state, 'themeSetting.filterLayout', ''),
  };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(PreviewVisualEditor));
